import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const sessionId = new URLSearchParams(
      (location.hash || "").replace(/^#/, "")
    ).get("session_id");

    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }

    const exchange = async () => {
      try {
        const res = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        setUser(res.data);
        navigate("/account", { replace: true, state: { user: res.data } });
      } catch {
        navigate("/", { replace: true });
      }
    };
    exchange();
  }, [location.hash, navigate, setUser]);

  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center px-6 text-center">
      <div className="h-10 w-10 animate-spin-slow rounded-full border border-[#8B5CF6]/30 border-t-[#8B5CF6]" />
      <p className="eyebrow mt-8">Aligning your session</p>
      <p className="body-muted mt-3 text-sm">
        Establishing a secure connection to your path.
      </p>
    </div>
  );
}
